/**
 * Static files API endpoints.
 *
 * Manages per-site static files (fonts, CSS, JS) on the filesystem.
 */

import { api } from './client';
import type { ApiResponse } from '../types';

/** A static file entry returned by the list endpoint */
export interface StaticFile {
  path: string;
  size_bytes: number;
  extension: string;
  category: 'fonts' | 'css' | 'js' | 'other';
  template_path: string;
}

/** Response shape for listing static files */
export interface StaticFilesListResponse {
  files: StaticFile[];
}

/** Static Files API */
export const staticFilesApi = {
  /** List all static files for a site */
  list: (siteSlug: string) =>
    api.get<ApiResponse<StaticFilesListResponse>>(`/v1/sites/${siteSlug}/static`),

  /** Upload a static file */
  upload: (siteSlug: string, file: File, subPath?: string): Promise<ApiResponse<StaticFile>> => {
    const formData = new FormData();
    formData.append('file', file);

    const params = subPath ? `?path=${encodeURIComponent(subPath)}` : '';
    return api.post<ApiResponse<StaticFile>>(`/v1/sites/${siteSlug}/static${params}`, formData);
  },

  /** Delete a static file */
  delete: (siteSlug: string, filePath: string) =>
    api.delete<ApiResponse<null>>(`/v1/sites/${siteSlug}/static/${filePath}`),
};
